import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ab0e317")

_pushScopeId("data-v-4ab0e317")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Disponibilità e indisponibilità")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "nuova_richiesta" }
const _hoisted_5 = { class: "events_switcher_container" }
const _hoisted_6 = { class: "events_switcher" }
const _hoisted_7 = {
  key: 0,
  class: "container_richieste"
}
const _hoisted_8 = { class: "container_selected_day" }
const _hoisted_9 = { class: "selected_day" }
const _hoisted_10 = { class: "day_action_buttons" }
const _hoisted_11 = {
  key: 0,
  class: "no_richieste_container day_empty"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "no_richieste" }, "Nessuna richiesta per il giorno selezionato", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "richiesta_info" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "date" }
const _hoisted_17 = { class: "orari" }
const _hoisted_18 = { class: "status" }
const _hoisted_19 = {
  key: 1,
  class: "no_richieste_container"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "no_richieste" }, "Nessuna richiesta effettuata", -1)
const _hoisted_21 = {
  key: 2,
  class: "container_richieste"
}
const _hoisted_22 = { class: "richiesta_info" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "date" }
const _hoisted_25 = { class: "orari" }
const _hoisted_26 = { class: "status" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadRichieste()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("button", {
                    class: "richiesta_button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openModal()))
                  }, "Nuova richiesta")
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("div", {
                      class: ["type", [$setup.selectedTab == 1 ? 'active' : '']],
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.setActiveTab(1)))
                    }, "Calendario", 2),
                    _createVNode("div", {
                      class: ["type", [$setup.selectedTab == 2 ? 'active' : '']],
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.setActiveTab(2)))
                    }, "Lista", 2)
                  ])
                ]),
                ($setup.showCalendar)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode(_component_Calendar, {
                        value: $setup.date,
                        attributes: $setup.calendarAttributes,
                        onDayclick: $setup.dayClicked,
                        "is-expanded": "",
                        class: "calendar_container"
                      }, null, 8, ["value", "attributes", "onDayclick"]),
                      _createVNode("div", _hoisted_8, [
                        _createVNode("div", _hoisted_9, _toDisplayString($setup.selectedDay && $setup.selectedDay.id ? $setup.dateLabel($setup.selectedDay.id) : $setup.dateLabel($setup.date)), 1),
                        _createVNode("div", _hoisted_10, [
                          (!$setup.nascondiDisponibilita)
                            ? (_openBlock(), _createBlock("button", {
                                key: 0,
                                class: "richiesta_button day_action_btn",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openModal('6', $setup.getDefaultModalDate())))
                              }, " Disponibilità "))
                            : _createCommentVNode("", true),
                          (!$setup.nascondiIndisponibilita)
                            ? (_openBlock(), _createBlock("button", {
                                key: 1,
                                class: "richiesta_button day_action_btn",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openModal('7', $setup.getDefaultModalDate())))
                              }, " Indisponibilità "))
                            : _createCommentVNode("", true)
                        ]),
                        (!$setup.richiesteToShow.length)
                          ? (_openBlock(), _createBlock("div", _hoisted_11, [
                              _hoisted_12
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_13, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.richiesteToShow, (richiesta) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "richiesta",
                                  key: `cal_${richiesta.richieste_id}`,
                                  onClick: ($event: any) => ($setup.openRichiestaDetail(richiesta))
                                }, [
                                  _createVNode("div", _hoisted_14, [
                                    _createVNode("div", {
                                      class: "fake_border",
                                      style: {backgroundColor: richiesta.richieste_tipologia_colore || '#ccc'}
                                    }, null, 4),
                                    _createVNode("div", null, [
                                      _createVNode("div", _hoisted_15, _toDisplayString(richiesta.richieste_tipologia_value), 1),
                                      _createVNode("div", _hoisted_16, _toDisplayString($setup.dataRichiesta(richiesta.richieste_dal, richiesta.richieste_al)), 1),
                                      _createVNode("div", _hoisted_17, " Dalle " + _toDisplayString(richiesta.richieste_ora_inizio) + " alle " + _toDisplayString(richiesta.richieste_ora_fine), 1)
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_18, [
                                    _createVNode("span", {
                                      class: ["badge", $setup.statoRichiesta(richiesta.richieste_stato_id)]
                                    }, _toDisplayString(richiesta.richieste_stato_value), 3)
                                  ])
                                ], 8, ["onClick"]))
                              }), 128))
                            ]))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.showList && !$setup.richieste.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      _hoisted_20
                    ]))
                  : _createCommentVNode("", true),
                ($setup.showList && $setup.richieste.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.richieste, (richiesta) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "richiesta",
                          key: richiesta.richieste_id,
                          onClick: ($event: any) => ($setup.openRichiestaDetail(richiesta))
                        }, [
                          _createVNode("div", _hoisted_22, [
                            _createVNode("div", {
                              class: "fake_border",
                              style: {backgroundColor: richiesta.richieste_tipologia_colore || '#ccc'}
                            }, null, 4),
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_23, _toDisplayString(richiesta.richieste_tipologia_value), 1),
                              _createVNode("div", _hoisted_24, _toDisplayString($setup.dataRichiesta(richiesta.richieste_dal, richiesta.richieste_al)), 1),
                              _createVNode("div", _hoisted_25, " Dalle " + _toDisplayString(richiesta.richieste_ora_inizio) + " alle " + _toDisplayString(richiesta.richieste_ora_fine), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_26, [
                            _createVNode("span", {
                              class: ["badge", $setup.statoRichiesta(richiesta.richieste_stato_id)]
                            }, _toDisplayString(richiesta.richieste_stato_value), 3)
                          ])
                        ], 8, ["onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})